import React from "react"
import { IRecord } from "../types/schema"
import { ProductSelect2 } from "./ProductSelect2"

export type IProductForSelect = IRecord<
  "products",
  | "stock_code"
  | "body"
  | "cost_price_pennies"
  | "preferred_supplier_list_price_pennies"
  | "sage_id"
  | "active"
  | "product_master"
> & {
  legacy_stock_code?: string
  line_item_description?: string
  product_locations: IRecord<
    "product_locations",
    "name" | "free_stock" | "warehouse" | "specific_location"
  >[]
  alternative?: { id: string } | string
  is_consignment?: boolean
  stockLevels?: { availableInStock?: number }
}

export function ProductSelect(props: {
  value?: IProductForSelect | string | null
  onChange?(value: IProductForSelect): void
  error?: string
  autoFocus?: boolean
  disabled?: boolean
  hideStock?: boolean
  label?: string
  filter?: Record<string, any>
  isClearable?: boolean
  showRequiredStar?: boolean
  preventSelectUnexported?: boolean
  branchId?: string
}) {
  return <ProductSelect2 {...props} />
}

export function highlight(
  text: string,
  query: string,
  opts?: { wrap: (textEl: string) => React.ReactNode },
) {
  const queryParts = query.toUpperCase().trim().split(/\s+/)

  const outputParts: React.ReactNode[] = []

  let j = 0
  for (let i = 0; i < text.length; i++) {
    const match = queryParts.find(part => text.toUpperCase().slice(i, i + part.length) === part)
    if (match) {
      outputParts.push(text.slice(j, i))
      outputParts.push(
        opts?.wrap ? (
          opts.wrap(text.slice(i, i + match.length))
        ) : (
          <u>{text.slice(i, i + match.length)}</u>
        ),
      )
      j = i + match.length
    }
  }
  outputParts.push(text.slice(j))

  return <React.Fragment>{outputParts}</React.Fragment>
}
